export default function FooterSection() {
  return (
    <footer id="footer" className="bg-foreground-900 text-foreground-300">
      <div className="px-4 md:px-6 mx-auto max-w-[1440px] py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <a href="#hero" className="inline-block mb-3 no-underline">
              <span className="text-2xl font-heading font-bold text-accent-400">90影视</span>
            </a>
            <p className="text-sm leading-relaxed text-foreground-400">
              90影视官网提供高清电影电视剧免费在线观看，最新地址一键直达，支持APP下载，海量影视资源全集不缓冲，安全访问90影视网站。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">快速导航</h3>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors no-underline">首页</a>
              <a href="#faq" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors no-underline">常见问题</a>
              <a href="#features" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors no-underline">平台特色</a>
              <a href="#ranking" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors no-underline">热度榜单</a>
              <a href="#carousel" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors no-underline">精选专题</a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">内容分类</h3>
            <div className="flex flex-col gap-2">
              <a href="#index" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors no-underline">影视索引</a>
              <a href="#cards" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors no-underline">精选片单</a>
              <a href="#updates" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors no-underline">更新快讯</a>
              <a href="#topics" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors no-underline">热门话题</a>
              <a href="#app" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors no-underline">APP下载</a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h3>
            <p className="text-xs text-foreground-500 leading-relaxed">
              90影视与多家内容平台保持友好合作关系，共同为影迷提供更丰富的观影选择。合作伙伴信息持续更新中。
            </p>
            <div className="mt-4">
              <h3 className="text-sm font-semibold text-background-50 mb-3">关注我们</h3>
              <div className="flex items-center gap-3">
                <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-accent-500 text-foreground-300 hover:text-background-50 transition-colors no-underline" aria-label="微信">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-accent-500 text-foreground-300 hover:text-background-50 transition-colors no-underline" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-accent-500 text-foreground-300 hover:text-background-50 transition-colors no-underline" aria-label="邮箱">
                  <i className="ri-mail-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2020-2026 90影视 版权所有。本站内容仅供学习交流，请于下载后24小时内删除。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#hero" className="hover:text-accent-400 transition-colors no-underline">服务条款</a>
            <a href="#hero" className="hover:text-accent-400 transition-colors no-underline">隐私政策</a>
            <a href="#contact" className="hover:text-accent-400 transition-colors no-underline">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}